/* 🚪 groupLeave — the admin role passes on when the last active admin leaves (the app's
   services/groupLeave.ts, the same rule: the longest-standing active member inherits it). */
const arr = (v) => (Array.isArray(v) ? v.map(String) : []);
const ms = (v) => {
  if (!v) return Number.POSITIVE_INFINITY;
  if (typeof v === 'number') return v;
  if (typeof v.toMillis === 'function') return v.toMillis();
  if (typeof v.seconds === 'number') return v.seconds * 1000;
  return Number.POSITIVE_INFINITY;
};
export function successorFor(group, leaver) {
  const left = new Set(arr(group && group.leftParticipants));
  left.add(String(leaver));
  const active = arr(group && group.participants).filter((u) => !left.has(u));
  if (!active.length) return null;
  const admins = arr(group && group.admins).filter((u) => !left.has(u));
  if (admins.some((a) => active.includes(a))) return null;
  const joined = (group && group.joinedAt) || {};
  const order = new Map(arr(group && group.participants).map((u, i) => [u, i]));
  return active.slice().sort((a, b) => (ms(joined[a]) - ms(joined[b])) || ((order.get(a) || 0) - (order.get(b) || 0)))[0] || null;
}
export function adminsAfterLeave(group, leaver) {
  const admins = arr(group && group.admins);
  if (!admins.includes(String(leaver))) return undefined;
  const next = admins.filter((a) => a !== String(leaver));
  const heir = successorFor(group, leaver);
  if (heir && !next.includes(heir)) next.push(heir);
  return next;
}
